import {
  ADD_CHITTIES_STARTED,
  ADD_CHITTIES_COMPLETED,
  ADD_CHITTIES_ERROR,
  FETCH_CHITTIES_STARTED,
  FETCH_CHITTIES_COMPLETED,
  FETCH_CHITTIES_ERROR,
  CLEAR_CHITTIES,
  EDIT_CHITTY_STARTED,
  EDIT_CHITTY_COMPLETED,
  EDIT_CHITTY_ERROR,
  ADD_CHITTIEUSERS_STARTED,
  ADD_CHITTIEUSERS_COMPLETED,
  ADD_CHITTIEUSERS_ERROR,
  REPLACE_CHITTYUSER_STARTED,
  REPLACE_CHITTYUSER_COMPLETED,
  REPLACE_CHITTYUSER_ERROR,
  SORT_CHITTIES_STARTED,
  SORT_CHITTIES_COMPLETED,
  SORT_CHITTIES_ERROR,
  FETCH_ALL_CHITTIES_STARTED,
  FETCH_ALL_CHITTIES_COMPLETED,
  FETCH_ALL_CHITTIES_ERROR,
  FETCH_COMPLETED_CHITTIES_STARTED,
  FETCH_COMPLETED_CHITTIES_COMPLETED,
  FETCH_COMPLETED_CHITTIES_ERROR
} from '../actionTypes/chittiesActionTypes';

const INITIAL_STATE = {
  submitted: false,
  success: false,
  error: false,
  chitties: {},
  completedChitties: {}
};

function chittiesReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case ADD_CHITTIES_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_CHITTIES_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case ADD_CHITTIES_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_CHITTIES_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_CHITTIES_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          chitties: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_CHITTIES_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case CLEAR_CHITTIES: {
      return {
        ...state,
        chitties: {},
        submitted: false,
        success: true
      };
    }
    case EDIT_CHITTY_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case EDIT_CHITTY_COMPLETED: {
      return {
        ...state,
        submitted: false,
        success: true
      };
    }
    case EDIT_CHITTY_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case ADD_CHITTIEUSERS_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case ADD_CHITTIEUSERS_COMPLETED: {
      state.chitties[action.id].chittieUsers = action.payLoad;
      return {
        ...state,
        chitties: { ...state.chitties },
        submitted: false,
        success: true
      };
    }
    case ADD_CHITTIEUSERS_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case REPLACE_CHITTYUSER_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case REPLACE_CHITTYUSER_COMPLETED: {
      let newUserKey = Object.keys(action.payLoad);
      let oldUserKey = Object.keys(action.oldUser);
      delete state.chitties[action.id].chittieUsers[oldUserKey];
      state.chitties[action.id].chittieUsers[newUserKey] = action.payLoad[newUserKey];
      if (!state.chitties[action.id].replacedUsers) {
        let replacedUser = {};
        replacedUser[oldUserKey] = action.oldUser[oldUserKey];
        state.chitties[action.id].replacedUsers = replacedUser;
      } else {
        state.chitties[action.id].replacedUsers[oldUserKey] = action.oldUser[oldUserKey];
      }
      return {
        ...state,
        chitties: { ...state.chitties },
        submitted: false,
        success: true
      };
    }
    case REPLACE_CHITTYUSER_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case SORT_CHITTIES_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case SORT_CHITTIES_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          chitties: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case SORT_CHITTIES_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_ALL_CHITTIES_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_ALL_CHITTIES_COMPLETED: {
      return {
        ...state,
        chitties: { ...action.payLoad },
        submitted: false,
        success: true
      };
    }
    case FETCH_ALL_CHITTIES_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    case FETCH_COMPLETED_CHITTIES_STARTED: {
      return {
        ...state,
        submitted: true
      };
    }
    case FETCH_COMPLETED_CHITTIES_COMPLETED: {
      if (action.payLoad) {
        return {
          ...state,
          completedChitties: { ...action.payLoad },
          submitted: false,
          success: true
        };
      } else {
        return {
          ...state,
          submitted: false,
          success: true
        };
      }
    }
    case FETCH_COMPLETED_CHITTIES_ERROR: {
      return {
        ...state,
        submitted: false,
        error: true
      };
    }
    default:
      return state;
  }
}

export default chittiesReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/chittiesReducer.js